import React, {PureComponent} from 'react'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import PropTypes from 'prop-types'

export class YesNoRadio extends PureComponent {
  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func
  }

  get value(){
    switch (this.props.value) {
      case true: return 'true'
      case false: return 'false'
      default: return ''
    }
  }

  parseValue(value) {
    switch (value) {
      case 'true': return true
      case 'false': return false
      default: return null
    }
  }

  handleChange = event => {
    this.props.onChange && this.props.onChange({target: {value: this.parseValue(event.target.value)}})
  }


  render = () => {
    const {className, styles, name, disabled} = this.props
    return (
      <RadioGroup name={name} className={className} styles={styles} onChange={this.handleChange} value={this.value}>
        <FormControlLabel value="true" control={<Radio disabled={disabled}/>} label="Yes"/>
        <FormControlLabel value="false" control={<Radio disabled={disabled}/>} label="No"/>
      </RadioGroup>
    )
  }
}

export default YesNoRadio